import { isTestCaseList, TestCaseList } from "@design-controls/types";
import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { useCurrentProduct } from "../useCurrentProduct";

export const useTestCaseList = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  const { isLoading, data } = useQuery<any, any, TestCaseList[]>({
    queryFn: () => designControlsApi.query(companyId, productId),
    queryKey: ["OPEN_ISSUE_LIST", companyId, productId],
    select: (records) => records.filter(isTestCaseList),
  });

  return {
    isLoading,
    data,
  };
};
